var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.5C1.17157 6.5 0.5 7.17157 0.5 8C0.5 8.82843 1.17157 9.5 2 9.5V6.5ZM13.0607 0.93934C12.4749 0.353554 11.5251 0.353554 10.9393 0.93934C10.3536 1.52513 10.3536 2.47487 10.9393 3.06066L13.0607 0.93934ZM18 8L19.0607 9.06066L20.1213 8L19.0607 6.93934L18 8ZM10.9393 12.9393C10.3536 13.5251 10.3536 14.4749 10.9393 15.0607C11.5251 15.6464 12.4749 15.6464 13.0607 15.0607L10.9393 12.9393ZM2 9.5H17.5V6.5H2V9.5ZM10.9393 3.06066L16.9393 9.06066L19.0607 6.93934L13.0607 0.93934L10.9393 3.06066ZM16.9393 6.93934L10.9393 12.9393L13.0607 15.0607L19.0607 9.06066L16.9393 6.93934Z",
    fill: "#E12A0E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRed);
export default __webpack_public_path__ + "static/media/arrow-red.81e4774d15aaadd44bbcbb6355efaee9.svg";
export { ForwardRef as ReactComponent };